import React from "react";
import InfoTitle from "./InfoTitle";
import TimeIndicatorGroup from "./TimeIndicatorGroup";

const InfoSection = ({ checkIn, checkOut, sozlesme }) => {
  return (
    <div className="flex flex-col items-center gap-4 mb-4 lg:flex-row lg:gap-0 lg:mb-9">
      <div className="w-full lg:w-1/5">
        <InfoTitle sozlesme={sozlesme} />
      </div>
      {checkIn && checkOut && <div className="w-full lg:w-4/5">
        <TimeIndicatorGroup checkIn={checkIn} checkOut={checkOut} />
      </div>}
    </div>
  );
};

export default InfoSection;
